import { isDefined, type TeamData, type TeamId } from '@terros/common'
import { getAncestorTeams, type TeamRelations } from './sortTeams'

type VisibleTeamsInput = {
  relations: TeamRelations<TeamData>
  boundaries: Map<TeamId, TeamData>
  focusTeamId: TeamId | null
}

export const toVisibleTeamIds = ({
  relations,
  boundaries,
  focusTeamId,
}: VisibleTeamsInput): Set<TeamId> | undefined => {
  if (!isDefined(focusTeamId)) return
  if (!relations.teamsById.has(focusTeamId)) return

  const boundary = boundaries.get(focusTeamId)
  if (!boundary) return new Set(relations.teamsById.keys())

  const visible = new Set<TeamId>()
  for (const team of relations.teamsById.values()) {
    const isWithinBoundary =
      team.teamId === boundary.teamId ||
      getAncestorTeams(team, relations).some((ancestor) => ancestor.teamId === boundary.teamId)
    if (isWithinBoundary) visible.add(team.teamId)
  }

  return visible
}
